// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"120":"8e7cf893","132":"f53744d7","182":"65be3cd1","551":"c10fb1a8","828":"952df359","842":"936ea731"}[chunkId] + ".chunk.js";
};